module.exports = __webpack_public_path__ + "media/images/key-68b887534b16ca98d6e07a07e7cbd4a8.png";